export { default } from './brain-games/BrainTrainingGames';
export {
    BRAIN_TRAINING_GAME_MENU_ITEMS,
    BrainTrainingGamesStyles,
    getBrainTrainingGameMenuItems,
    getBrainTrainingGameFromHash,
    getBrainTrainingGameHref,
} from './brain-games/BrainTrainingGames';
export { BrainTrainingGameIcon } from './brain-games/shared';
